import { PureFunctional, React } from '../../react';
import { IBookmark, INote, isNote, isSharedNote, INoteAndParticipant } from '../../types';
import { bookmarksResource } from '../bookmarks/resource';
import DataItemNote from '../dataitem';
import DataItemBookMark from '../dataitembookmark';
import Dataitemquestion from '../dataitemquestion';
import Hint from '../hint';
import { notesResource } from '../notes/resource';
import { notesSharedResource } from '../noteshared/resource';

import cx from './style.less';

interface IDataListProps {
    items: INoteAndParticipant[];
    empty: string;
    visible?: boolean;
}

export const DataList = PureFunctional<any | IDataListProps>('DataList')(
    ({ items, empty }) => {
        if (!items.length) {
            return <Hint text={empty} />;
        }

        return (
            <div className={cx('data-list')}>
                <ul className={cx('data-list-container')} tabIndex={-1}>
                    {items.qSelect((item: INoteAndParticipant) => (
                        (!!isSharedNote(item.item) || !!isNote(item.item)) && !item.item.isquestion?
                            <DataItemNote
                                key={isSharedNote(item.item) ? notesSharedResource.fields.key(item.item) :
                                    (isNote(item.item) ? notesResource.fields.key(item.item) : bookmarksResource.fields.key(item.item))} item={item.item as INote} participant={item.user} /> :
                        (!!isSharedNote(item.item) || !!isNote(item.item)) && item.item.isquestion?
                            <Dataitemquestion
                                    key={isSharedNote(item.item) ? notesSharedResource.fields.key(item.item) :
                                        (isNote(item.item) ? notesResource.fields.key(item.item) : bookmarksResource.fields.key(item.item))} item={item.item as INote} participant={item.user} /> :
                            <DataItemBookMark key={bookmarksResource.fields.key(item.item)} item={item.item as IBookmark} />
                    ),
                    )}
                </ul>
            </div>
        );
    });



// WEBPACK FOOTER //
// (webpack)-remove-block-loader??ref--5-0!./src/note/datalist/index.tsx